import React from "react";
import PropTypes from 'prop-types'

import styles from './transactions.module.css';
import { capitalize } from "utils/stringServices";

/**
 * 
 * @param {pending | completed | cancelled} variant This specify the status of transaction
 * @param {String} text This specify the optional text to show
 *  
 */

const Status = ({variant="pending", className, text ,...props}) => {
    return (
        <div className={`${styles.Status} ${styles[variant]} ${className|| ""}`} {...props}>
          <span></span> <span>
              {text ? text : capitalize(variant)}
              </span>

        </div>
    )
}

Status.propTypes ={
    variant: PropTypes.oneOf(['pending',"completed","cancelled"]).isRequired,
    text: PropTypes.string
}
export default Status